import * as React from "react";
import { useRef } from "react"
import { Calendar } from "react-multi-date-picker"
import ProfessionalItem from "./ProfessionalItem";
import {Api} from "../../lib/Api";
import {start} from "repl";
import ImageUpload from "../global/ImageUpload";

interface ISelectProfessionalProps {
    professional: any
    confirmOrder: Function
}

interface ISelectProfessionalState{
    description: string
    times: Array<any>
    selectedDate: any
    selectedTimeIndex:any
    selectedHour: any
    photo: any


}


export default class SelectProfessional extends React.Component<ISelectProfessionalProps, ISelectProfessionalState> {

    constructor(props: ISelectProfessionalProps) {
        super(props);
        this.state = {
            description: '',
            times: [],
            selectedDate: new Date(),
            selectedTimeIndex: 0,
            selectedHour: 1,
            photo: ''


        };

        this.getTimes(this.state.selectedDate);
    }




    private getTimes(selectedDate){
        Api.call('/user/restaurant/getFreeTimes', {
            offerId: this.props.professional.id,
            selectedDate: selectedDate
        }, (result) =>{
            if(result.success) {
                this.setState({
                    times: result.times,
                    selectedDate: selectedDate,
                    selectedHour: 1,
                    selectedTimeIndex: 0
                })
            } else {
                this.setState({
                    times: []
                })
            }
        })

    }

    private changeDate(type){
        let date = new Date(this.state.selectedDate);
        let selectedDate = new Date(type == "increase" ? date.setDate(date.getDate() + 1) : date.setDate(date.getDate() - 1));
        this.setState({
            selectedDate: selectedDate
        });
        this.getTimes(selectedDate);

    }

    private changeTime(type){

        let index = this.state.selectedTimeIndex;
        if(type == 'increase' && this.state.times.length > index + 1) {
            console.log(type);
            this.setState({
                selectedTimeIndex: index + 1,
                selectedHour: 1
            });
        }

        if(type == 'decrease' && index > 0) {
            console.log(type);
            this.setState({
                selectedTimeIndex: index - 1,
                selectedHour: 1
            });
        }
    }

    private changeHour(type){

        let hour = this.state.selectedHour;
        let selectedTime = this.state.times[this.state.selectedTimeIndex];

        if(type == 'increase' && selectedTime.hours >= hour + 1) {
            this.setState({
                selectedHour: hour + 1
            });
        }

        if(type == 'decrease' && hour > 0) {
            this.setState({
                selectedHour: hour - 1
            });
        }



    }

    private addHours(date, hours) {
        date.setTime(date.getTime() + hours * 60 * 60 * 1000);

        return date;
    }

    private confirmOrder(){

        let year = new Date(this.state.selectedDate).getFullYear();
        let month = new Date(this.state.selectedDate).getMonth();
        let day = new Date(this.state.selectedDate).getDate();
        let time = this.state.times[this.state.selectedTimeIndex].time.split(':');


        let startDateTime = new Date(year, month, day, time[0], time[1]);
        let endDateTime = new Date(year, month, day, time[0], time[1]);
        endDateTime = this.addHours(endDateTime, this.state.selectedHour);


        this.props.confirmOrder({
            startDateTime: startDateTime,
            endDateTime: endDateTime,
            hours: this.state.selectedHour,
            description: this.state.description,
            photo: this.state.photo
        });

    }

    private savePhoto(file) {
        this.setState({
            photo: file
        });
    }

    render() {
        return (

            <div className = "selected_professional">
                <h1>Selected Service:</h1>
                <ProfessionalItem professional={this.props.professional} index={0} />
                <h1>Choose a date:</h1>


                <div className = "select-date">
                    <div>
                        <button className = "select-button" onClick={() => this.changeDate('increase')}><img className="transform-180deg" src = "img/arrow_icon.svg" /></button>
                        <div className = "date">
                            {new Date(this.state.selectedDate).getDate()} {new Date(this.state.selectedDate).toLocaleDateString('default', {month: 'short'})}
                        </div>
                        <button className = "select-button" onClick={() => this.changeDate('decrease')}><img src = "img/arrow_icon.svg" /></button>
                    </div>
                        {
                            this.state.times.length > 0 &&
                            <div>
                                <button className = "select-button" onClick={() => this.changeTime('increase')}><img className="transform-180deg" src = "img/arrow_icon.svg" /></button>
                                <div className = "time">
                                    {this.state.times[this.state.selectedTimeIndex].time}
                                </div>
                                <button className = "select-button" onClick={() => this.changeTime('decrease')}><img src = "img/arrow_icon.svg" /></button>
                            </div>

                        }
                        {
                            this.state.times.length > 0 &&
                            <div>
                                <button className = "select-button" onClick={() => this.changeHour('increase')}><img className="transform-180deg" src = "img/arrow_icon.svg" /></button>
                                <div className = "interval">
                                    {this.state.selectedHour} hours
                                </div>
                                <button className = "select-button" onClick={() => this.changeHour('decrease')}><img src = "img/arrow_icon.svg" /></button>
                            </div>

                        }

                </div>
                <div className = "description_box">
                  <textarea className="s-form-control" name="description" rows={8} placeholder="Short description of work"
                            onChange={(e) => this.setState({description: e.target.value})}></textarea>
                </div>

                <ImageUpload label={'Upload your photos'} id={'upload_offer_img'} icon={'/img/upload_photo_icon.png'} change={(file) => this.savePhoto(file)} value={this.state.photo} />


                <div className = "order-btn">
                    <button type="button" className="purple_btn" onClick={(e) => this.confirmOrder()}>Continue to order</button>
                </div>
            </div>
        );
    };
}
